<template>
  <form autocomplete="off">
    <q-toggle
      v-model="details.enabled"
      label="Включен"
    />
    <q-field>
      <q-input
        v-model="details.requisites.tin"
        stack-label="ИНН"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.bank_name"
        stack-label="Название банка"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.checking_account"
        stack-label="Номер рассчетного счёта"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.custom_data"
        stack-label="Особые настройки"

      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.additional_info"
        stack-label="Дополнительная информация"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.sender"
        stack-label="Отправитель счёта"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.address"
        stack-label="Адрес"
        type="textarea"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.name_in_signature"
        stack-label="ФИО в подписи"
      />
    </q-field>
    <q-field>
      <q-uploader
        v-if="!details.requisites.stamp_img_url"
        url="/api/v1.0/media/service-providers/"
        :upload-factory="uploadFile"
        extensions=".png"
        :multiple="false"
        :auto-expand="true"
        :hide-upload-button="true"
        @add="$refs.uploader.upload()"
        ref="uploader"
        float-label="Изображение печати"
      />
      <div
        v-else
        class="q-if q-if-standard q-if-has-label q-if-hide-underline"
      >
        <div class="q-if-label q-if-label-above">
          <div class="q-if-label-inner ellipsis">Изображение печати (200 × 150)</div>
        </div>
        <div style="position: relative; display: inline-block; margin-top: 6px;">
          <a
            :href="details.requisites.stamp_img_url"
            target="_blank"
          >
            <img
              :src="details.requisites.stamp_img_url"
              alt=""
              style="width: 100px; height: auto; vertical-align: middle;"
            >
          </a>
          <q-btn
            @click="details.requisites.stamp_img_url = ''"
            icon="edit"
            color="primary"
            flat
            round
            style="position: absolute; bottom: 0; left: 100%;"
          />
        </div>
      </div>
    </q-field>
    <div class="q-mt-lg row justify-end items-center">
      <div>
        <q-btn
          @click="save()"
          :loading="saving"
          label="Сохранить"
          color="primary"
        />
        <q-btn
          @click="$emit('close')"
          color="primary"
          flat
          label="Закрыть"
        />
      </div>
    </div>
  </form>
</template>

<script>
  import harvester from './mixins/harvester';

  import {
    QField,
    QInput,
    QToggle,
    QBtn,
    QUploader
  } from 'quasar';

  export default {
    name: 'InvoiceMethod',
    components: {
      QField,
      QInput,
      QToggle,
      QBtn,
      QUploader
    },
    mixins: [
      harvester
    ],
    props: {
      provider: Object,
      details: {
        type: Object,
        default () {
          return {
            enabled: false,
            payment_method: 'invoice',
            requisites: {
              tin: null,
              address: '',
              checking_account: '',
              bank_name: '',
              mfi: null,
              additional_info: '',
              sender: '',
              stamp_img_url: '',
              name_in_signature: ''
            }
          };
        }
      }
    },
    methods: {
      uploadFile (file, updateProgress) {
        let formData = new FormData(),
          config = {
            onUploadProgress: function (progressEvent) {
              updateProgress(progressEvent.loaded / progressEvent.total);
            }
          };

        formData.append('image', file);
        return new Promise((resolve, reject) => {
          this.api.post(`/payment-details/${this.details.id}/stamp`, formData, config).then(response => {
            this.details.requisites.stamp_img_url = new URL(response.data.data.path).pathname;
            resolve(file);
          }).catch(error => {
            reject(error);
            console.error(error);
          });
        });
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PaymentMethodEdit/methods/InvoiceMethod.vue